export default {
    methods: {
        df_currentDateTime: function (format) {
            var fillZero = function ( number ) {
                return ("0" + number).slice(-2);
            }                      
            const d = new Date()

            if (format == undefined || format == null || format == 'yyyy-MM-dd HH:mm:ss') {
                var currentDateTime = d.getFullYear() + "-" + fillZero(d.getMonth()+1) + "-" + fillZero(d.getDate()) + " " +
                                    fillZero(d.getHours()) + ":" + fillZero(d.getMinutes()) + ":" + fillZero(d.getSeconds())
                return currentDateTime
            }

            switch(format) {
                case "yyyy-MM-dd":
                    var currentDateTime = d.getFullYear() + "-" + fillZero(d.getMonth()+1) + "-" + fillZero(d.getDate())
                    return currentDateTime
                case "yyyyMMddHHmmss":
                    var currentDateTime = d.getFullYear() + fillZero(d.getMonth()+1) + fillZero(d.getDate()) +
                    fillZero(d.getHours()) + fillZero(d.getMinutes()) + fillZero(d.getSeconds())
                    return currentDateTime
            }
        },
        df_dateFormatter: function (date, format) {
            var fillZero = function ( number ) {
                return ("0" + number).slice(-2);
            }                      
            if (format == undefined || format == null || format == 'yyyy-MM-dd HH:mm:ss') {
                var currentDateTime = date.getFullYear() + "-" + fillZero(date.getMonth()+1) + "-" + fillZero(date.getDate()) + " " +
                                    fillZero(date.getHours()) + ":" + fillZero(date.getMinutes()) + ":" + fillZero(date.getSeconds())
                return currentDateTime
            }

            switch(format) {
                case "yyyy-MM-dd":
                    var currentDateTime = date.getFullYear() + "-" + fillZero(date.getMonth()+1) + "-" + fillZero(date.getDate())
                    return currentDateTime
                case "yyyy-MM-dd HH:mm:ss":
                    var currentDateTime = date.getFullYear() + "-" + fillZero(date.getMonth()+1) + "-" + fillZero(date.getDate()) + " " +
                    fillZero(d.getHours()) + ":" + fillZero(date.getMinutes()) + ":" + fillZero(date.getSeconds())
                    return currentDateTime
                case "yyyyMMddHHmmss":
                    var currentDateTime = date.getFullYear() + fillZero(date.getMonth()+1) + fillZero(date.getDate()) +
                    fillZero(d.getHours()) + fillZero(date.getMinutes()) + fillZero(date.getSeconds())
                    return currentDateTime
                }
        }
    }
}
